
import React from 'react';
import PropTypes from 'prop-types';
import { css } from 'aphrodite';

import { position } from '../../../../../../../commonStyles.js';
import styles from './styles.js';

const BackgroundImage = ({ children, image, isUpdating }) => {
    if (isUpdating) {
        return (
            <div className={css(styles.shimmer)}>
                <span
                    aria-busy="true"
                    className={css(styles.shimmerAnimation)}
                    style={{
                        width: '100%',
                        height: '100%'
                    }}
                />
            </div>
        );
    }
    return (
        <div
            className={css(
                position.absolute,
                styles.background,
                styles.backgroundSize_cover,
                styles.fadeIn
            )}
            style={
                image ? {
                    width: '100%',
                    height: '100%',
                    backgroundImage: `url("${image.large_url}")`
                } : null
            }
        >
            {
                children ?
                    <div className={css(styles.childContainer)}>
                        {children}
                    </div> : null
            }
        </div>
    );
};

BackgroundImage.propTypes = {
    children: PropTypes.node,
    image: PropTypes.object,
    isUpdating: PropTypes.bool
};

export default BackgroundImage;



// WEBPACK FOOTER //
// ./src/pages/Search/Main/CardSlider/CardContainer/Card/BackgroundImage/BackgroundImage.jsx